import { Modal } from '@/components/common';
import { buildColumn, ColumnsProps, ScrollType } from '@/Helper';
import { BaseColumns } from '@/model/CommonModel';
import { ConflictMessage } from '@/model/EnrollmentModel';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Table } from 'antd';
import React from 'react';
import styles from './controllerConflictWarningModal.module.scss';

type Props = {
	conflicts: ConflictMessage[];
	overlapAccessFlag: boolean;
	cCMVersion: string;
	customAccessZones: number;
	onOkClick: () => void;
};

type ConflictMessageColumn = ConflictMessage & BaseColumns;

const ControllerConflictWarningModal: React.FC<Props> = ({ conflicts, overlapAccessFlag, cCMVersion, customAccessZones, onOkClick }) => {
	const columns: ColumnsProps<ConflictMessageColumn>[] = [
		{
			...buildColumn(_('FunctionCategory'), 'CategoryName', 'auto', 'start'),
			render: functionCategory => <strong>{functionCategory}</strong>,
		},
		{
			...buildColumn(_('Function'), 'FunctionName', 'auto', 'start'),
			render: (_, fn) => {
				const descriptor = fn.Description && fn.Description.length > 0 ? ` (${fn.Description})` : undefined;
				return (
					<>
						<p className={styles.pStyle}>
							<strong>{fn.FunctionName}</strong>
							{descriptor}
						</p>
					</>
				);
			},
		},
		{
			...buildColumn(_('Controller'), 'ControllerName', 'auto', 'start'),
			render: controllerName => <strong>{controllerName}</strong>,
		},
	];

	const dataSource: ConflictMessageColumn[] = conflicts.map<ConflictMessageColumn>((cm, index) => ({
		key: `${cm.CategoryName}-${index}`,
		CategoryName: cm.CategoryName,
		FunctionName: cm.FunctionName,
		ControllerName: cm.ControllerName,
		Description: cm.Description,
	}));

	const footer = (
		<Button htmlType='button' onClick={onOkClick} type='default'>
			{_('Ok')}
		</Button>
	);

	return (
		<Modal customZoomClass={styles.modalWithAutoZoom} closable={false} footer={[footer]} visible width={650}>
			<div className={styles.container}>
				<div className={styles.functionsConflictsModal}>
					<InfoCircleOutlined className={styles.iconStyle} />
					{overlapAccessFlag ? (
						<p>
							{_('CredentialFunctionConflictMessage4')}
							<br />
							<br />
							{_('CredentialFunctionConflictMessage5').replace('%1', customAccessZones.toString()).replace('%2', cCMVersion)}
							<br />
						</p>
					) : (
						<p>
							{_('CredentialFunctionConflictMessage4')}
							<br />
							<br />
							{_('CredentialFunctionConflictMessage5').replace('%1', customAccessZones.toString()).replace('%2', cCMVersion)}
							<br />
							<br />
							{_('CredentialFunctionConflictMessage6').replace('%1', cCMVersion)}
							<br />
						</p>
					)}
				</div>
				<div className={styles.tableContainer}>
					<Table
						className={styles.tableStyle}
						scroll={{ y: 272 } as ScrollType}
						size='small'
						columns={columns}
						dataSource={dataSource}
						pagination={false}
					/>
				</div>
			</div>
		</Modal>
	);
};

export { ControllerConflictWarningModal };
